<ng-container *ngFor="let company of companyList; index as i; trackBy: trackByCompanyID">
  <div
    [id]="company.id"
    class="company is-animated"
    (click)="showCompany($event, company)"
    [ngClass]="{
      active: selectedCompanyID === company.id
    }"
  >
    <div>
      <h4>
        {{ company.name }}&nbsp;<span *ngIf="stepStatus === 5">{{ company.position_weight | percent: '1.0-1' }}</span>
      </h4>
      <div class="company-topics">
        <ng-container *ngFor="let topic of company.topics">
          <app-ui-tooltip
            [icon]="topic.icon"
            [content]="topic.desc"
            [title]="topic.name"
            size="large"
            (mouseenter)="trackTooltip(topic.name)"
          ></app-ui-tooltip>
        </ng-container>
      </div>
    </div>

    <div class="actions">
      <div class="chevron" [ngClass]="{ open: selectedCompanyID === company.id }"></div>
    </div>
  </div>
  <div *ngIf="selectedCompanyID === company.id">
    <app-setup-portfolio-company-detail [company]="company" [appLocation]="appLocation"></app-setup-portfolio-company-detail>
  </div>
</ng-container>
